import React, {Component} from 'react';
import {ContentMap} from '../config/contentMap';

// i18n
import { Translate } from 'react-redux-i18n';
import './formUnavailablePage.css';

class FormUnavailable extends Component{

    state = {
        errorId : 2
    }

    componentDidMount(){
        if(this.props.searchData.isPartnerContact && this.props.searchData.programType !== "APC")
        {
            this.setState({errorId:0});
        }
        if(this.props.searchData.isPartnerContact && this.props.searchData.programType === "APC")
        {
            this.setState({errorId:1});
        }
        else if(!this.props.searchData.isPartnerContact)
        {
            this.setState({errorId:2});
        }
        else
        {
            this.setState({errorId:3});
        }
    }

    render(){
        
        var TAG = ContentMap['unavailable'][this.state.errorId];
     
        return (<div>
            
            <TAG {...this.props} />
        </div>);
    }
}


  
export default FormUnavailable;